import React from "react";
import styles from "./ClientForm.module.css";

function WelcomeScreen({ formData }) {
  const applicant1Name = formData?.applicant1?.name || "there";

  return (
    <div
      className={styles.container}
      style={{
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "70vh",
      }}
    >
      <h2>🎉 Thank you, {applicant1Name}, for your enquiry!</h2>
      <p>
        We’ve received your details and one of our mortgage brokers will be in
        touch with you shortly.
      </p>
      <p>
        To save time, you can book your appointment now at a time that suits
        you.
      </p>

      <a
        href="https://www.mortgagematrix.com.au/get-started"
        target="_blank"
        rel="noopener noreferrer"
        className={styles.nextBtn}
        style={{
          textAlign: "center",
          display: "inline-block",
          marginTop: "20px",
          padding: "15px 40px",
          fontSize: "18px",
        }}
      >
        📅 Book Your Appointment
      </a>
    </div>
  );
}

export default WelcomeScreen;
